// Dark theme definition
export const DARK_THEME = {
  colors: [
    '#2b908f',
    '#90ee7e',
    '#f45b5b',
    '#7798BF',
    '#aaeeee',
    '#ff0066',
    '#eeaaee',
    '#55BF3B',
    '#DF5353',
    '#7798BF',
    '#aaeeee',
  ],

  chart: {
    backgroundColor: '#1e1e1e',
    style: {
      fontFamily: 'Arial, sans-serif',
    },
    plotBorderColor: '#606063',
  },

  title: {
    style: {
      color: '#FFFFFF',
      fontSize: '18px',
    },
  },

  subtitle: {
    style: {
      color: '#DDDDDD',
    },
  },

  xAxis: {
    gridLineColor: '#444444',
    labels: {
      style: {
        color: '#DDDDDD',
      },
    },
    lineColor: '#707073',
    minorGridLineColor: '#505053',
    tickColor: '#707073',
    title: {
      style: {
        color: '#AAAAAA',
      },
    },
  },

  yAxis: {
    gridLineColor: '#444444',
    labels: {
      style: {
        color: '#DDDDDD',
      },
    },
    lineColor: '#707073',
    minorGridLineColor: '#505053',
    tickColor: '#707073',
    tickWidth: 1,
    title: {
      style: {
        color: '#AAAAAA',
      },
    },
  },

  tooltip: {
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    style: {
      color: '#FFFFFF',
    },
  },

  legend: {
    backgroundColor: 'transparent',
    itemStyle: {
      color: '#E0E0E3',
    },
    itemHoverStyle: {
      color: '#FFF',
    },
    itemHiddenStyle: {
      color: '#606063',
    },
  },

  credits: {
    style: {
      color: '#666',
    },
  },

  labels: {
    style: {
      color: '#707073',
    },
  },

  navigation: {
    buttonOptions: {
      symbolStroke: '#DDDDDD',
      theme: {
        fill: '#505053',
      },
    },
  },
}
